import { render, staticRenderFns } from "./Composition.vue?vue&type=template&id=0dc21ead&"
import script from "./Composition.vue?vue&type=script&lang=js&"
export * from "./Composition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports